import { render } from "./PostList.vue?vue&type=template&id=134eeb28&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"

import "./PostList.vue?vue&type=style&index=0&id=134eeb28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-134eeb28"

export default script